import VideoAnalyticsPage from './VideoAnalyticsPage';
export default VideoAnalyticsPage;